import React from 'react';

export default function Loader() {
  return (
    <div className="loader_wrap">
      <span className="loader"></span>
    </div>
  );
}
